import { cva } from '@/styled-system/css';

export const toastRootRecipe = cva({
  base: {
    display: 'inline-flex',
    paddingInline: 'default',
    paddingBlock: 'default',
    borderRadius: 'obj.default',
    boxShadow: 'Toast',
    maxWidth: '500px',
  },
  variants: {
    tone: {
      info: {
        backgroundColor: 'Toast.info.bg',
        color: 'text.onImpact.neutral',
      },
      success: {
        backgroundColor: 'Toast.success.bg',
        color: 'text.onImpact.neutral',
      },
      warning: {
        backgroundColor: 'Toast.warning.bg',
        color: 'text.onImpact.neutral',
      },
      critical: {
        backgroundColor: 'Toast.critical.bg',
        color: 'text.onImpact.neutral',
      },
    },
  },
});
